var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "wkb-learn-panel",
      class: [
        `wkb-learn-panel--${_vm.variant}`,
        {
          "wkb-learn-panel--standalone":
            _vm.standalone && _vm.variant === "companion",
        },
      ],
      attrs: { "aria-labelledby": _vm.titleId },
    },
    [
      _vm.variant === "companion"
        ? _c("header", { staticClass: "wkb-learn-head" }, [
            _c(
              "h2",
              { staticClass: "wkb-learn-title", attrs: { id: _vm.titleId } },
              [_vm._v("Learn Canvas")]
            ),
            _vm.visitLabel
              ? _c("p", { staticClass: "wkb-learn-visit" }, [
                  _vm._v(_vm._s(_vm.visitLabel)),
                ])
              : _vm._e(),
            _vm._m(0),
          ])
        : _vm._e(),
      _vm.variant === "companion"
        ? [_vm._m(1), _vm._m(2), _vm._m(3)]
        : [
            _c("h3", { staticClass: "wkb-learn-section-title" }, [
              _vm._v("Starting a graph"),
            ]),
            _c("p", { staticClass: "wkb-learn-lead" }, [
              _vm._v(
                " New sessions begin with a small set of starting nodes—not a large auto-built neighborhood. "
              ),
            ]),
            _vm._m(4),
            _vm._m(5),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "wkb-learn-lead" }, [
      _vm._v(" Core ideas for using the graph and the "),
      _c("strong", [_vm._v("AI assistant")]),
      _vm._v(". "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "wkb-learn-list" }, [
      _c("li", [
        _c("strong", [_vm._v("Build step by step")]),
        _c("p", [
          _vm._v(
            " Start with a few genes, traits, or mechanisms. Grow the graph with "
          ),
          _c("em", [_vm._v("Expand KG")]),
          _vm._v(" instead of loading everything at once. "),
        ]),
      ]),
      _c("li", [
        _c("strong", [_vm._v("Selection matters")]),
        _c("p", [
          _c("em", [_vm._v("Selected nodes")]),
          _vm._v(
            " (blue) are what most assistant commands use. “All visible nodes” means everything currently shown on the canvas. "
          ),
        ]),
      ]),
      _c("li", [
        _c("strong", [_vm._v("Key actions")]),
        _c("p", [
          _c("em", [_vm._v("Expand")]),
          _vm._v(" adds neighbors · "),
          _c("em", [_vm._v("Add")]),
          _vm._v(" adds one entity · "),
          _c("em", [_vm._v("Filter")]),
          _vm._v(" hides nodes · "),
          _c("em", [_vm._v("Select")]),
          _vm._v(" marks nodes · "),
          _c("em", [_vm._v("Explain")]),
          _vm._v(" summarizes what you see. "),
        ]),
      ]),
      _c("li", [
        _c("strong", [_vm._v("AI assistant")]),
        _c("p", [
          _vm._v(" Click the "),
          _c("strong", { staticClass: "wkb-learn-emphasis" }, [_vm._v("AI")]),
          _vm._v(
            " button on the toolbar and describe changes in plain language. Suggestions appear as you type — use "
          ),
          _c("kbd", { staticClass: "wkb-learn-kbd" }, [_vm._v("↑")]),
          _c("kbd", { staticClass: "wkb-learn-kbd" }, [_vm._v("↓")]),
          _vm._v(", "),
          _c("kbd", { staticClass: "wkb-learn-kbd" }, [_vm._v("Tab")]),
          _vm._v(", or "),
          _c("kbd", { staticClass: "wkb-learn-kbd" }, [_vm._v("Enter")]),
          _vm._v(" to accept. "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "wkb-learn-examples" }, [
      _c("p", { staticClass: "wkb-learn-examples-title" }, [
        _vm._v("Try asking:"),
      ]),
      _c("ul", [
        _c("li", [_vm._v("Explain selected nodes")]),
        _c("li", [_vm._v("Select top 5 genes connected to Type 2 diabetes")]),
        _c("li", [_vm._v("Filter genes related to insulin resistance")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "wkb-learn-more" }, [
      _vm._v(" For menus, filters, and analysis details, open "),
      _c("strong", [_vm._v("Help → Documentation")]),
      _vm._v(". You can reopen this guide anytime from "),
      _c("strong", [_vm._v("Help → Learn Canvas")]),
      _vm._v(". "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "wkb-learn-list" }, [
      _c("li", [
        _c("strong", [_vm._v("Search & select")]),
        _c("p", [
          _vm._v(" From "),
          _c("em", [_vm._v("Manage → New graph")]),
          _vm._v(
            ", search genes, gene sets, mechanisms, and traits in four columns. Use catalog typeahead for exact names, or "
          ),
          _c("em", [_vm._v("By conceptual search")]),
          _vm._v(
            " when you have a topic (for example “insulin resistance”) but not a specific entity. Pick one or two entities to start, add optional context, then click "
          ),
          _c("em", [_vm._v("Build a KG")]),
          _vm._v(". "),
        ]),
      ]),
      _c("li", [
        _c("strong", [_vm._v("Neighboring nodes (optional)")]),
        _c("p", [
          _vm._v(
            " By default, the initial build adds only your starting entities and the links that connect them directly. Check "
          ),
          _c("em", [_vm._v("Add neighboring nodes")]),
          _vm._v(
            " if you want REVEAL to fetch extra neighbors in the first pass. Most sessions grow the graph gradually with "
          ),
          _c("em", [_vm._v("Expand KG")]),
          _vm._v(" instead. "),
        ]),
      ]),
      _c("li", [
        _c("strong", [_vm._v("Load or import")]),
        _c("p", [
          _c("em", [_vm._v("My library → Open on canvas")]),
          _vm._v(" restores a browser-saved layout. "),
          _c("em", [_vm._v("Manage → Import graph")]),
          _vm._v(
            " restores a full workflow file (including inspector caches and analysis runs). "
          ),
        ]),
      ]),
      _c("li", [
        _c("strong", [_vm._v("AI assistant")]),
        _c("p", [
          _vm._v(" After you have a graph, use the toolbar "),
          _c("strong", [_vm._v("AI")]),
          _vm._v(
            " button to describe changes in plain language. Selected nodes (blue) are the usual target. See the companion guide on your first few visits for examples. "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "wkb-learn-more" }, [
      _vm._v(
        " For the full guide (menus, toolbar, filters, and analysis), open "
      ),
      _c("strong", [_vm._v("Help → Documentation")]),
      _vm._v(". "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }